export const drafts = {
  pageHeader: 'Drafts',
  jobSearchHeader: 'Job Name',
  jobSearchPlaceholder: 'Search job name',
  jobPosterHeader: 'Job Poster',
  venueHeader: 'Location',
  button: {
    addNew: 'Post a Job'
  },
  filterFields: {
    requestorId: 'requestorId',
    dateRange: 'DATE_RANGE',
    search: 'search',
    venues: 'venueIds'
  },
  tableColumns: {
    requestName: 'JOB NAME',
    classification: 'CLASS',
    startDate: 'START DATE AND TIME',
    totalDuration: 'ESTIMATED TIME',
    requestorName: 'JOB POSTER',
    venue: 'LOCATION',
  },
  buttons: {
    edit: 'Edit',
    copy: 'Copy',
    delete: 'Delete',
    bulkDelete: 'Delete Selected',
    cancel: 'Cancel',
  },
  toast: {
    copySuccess: 'Draft Copied',
    copyError: 'There was an error copying this draft',
    deleteSuccess: 'Draft Deleted',
    deleteError: 'There was an error deleting this draft',
    bulkDeleteSuccess: 'Drafts Deleted',
    bulkDeleteError: 'There was an error deleting these drafts',
  },
  modalHeader: 'Delete Draft',
  modalConfirmation: 'Are you sure you want to permanently delete these drafts?',
  displayResults: {
    noContentHeaderV2: 'No jobs posted',
    noResults: 'Try different keywords or revising filters',
  },
};
